/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, August 24th 2022, 8:35:46 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Grid from "@mui/material/Grid";
import { COLORSCHEME } from "theme/styles";

interface FullScreenNotificationGridProps {
  pageTitle: React.ReactNode;
  pageContent: React.ReactNode;
  pageIllustration?: React.ReactNode;
  addtionalGridItems?: React.ReactNode;
}

export const FullScreenNotificationGrid = ({
  pageTitle,
  pageContent,
  pageIllustration,
  addtionalGridItems,
}: FullScreenNotificationGridProps) => (
  <Grid container spacing={2} sx={{ padding: "0px 100px 0px 100px" }}>
    <Grid item xs={12}>
      <div className="os-empty-state text-center">
        <div className="os-empty-state-component os-empty-state-component-A">
          <div className="os-card-style-A-in-image">{pageIllustration}</div>
          <h4 style={{ color: COLORSCHEME.primary }}>{pageTitle}</h4>
          {pageContent}
        </div>
      </div>
    </Grid>
    {addtionalGridItems}
  </Grid>
);
